import React, { useState } from 'react';
import 'antd/dist/antd.css';
import { Input, Table, Switch, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import {
    Button,
    Header,
    ButtonCustom,
    localeEmptyTable
} from '../../components';
import { searchIcon } from '../../assets/images/icons';
import { role } from '../../config/Constants';
import { ADD_NEW_SERVICES, SERVICES_DETAIL } from '../../routes/main';
import { numberFormat } from '../../utils';
import { isUserAdmin } from 'redux/selectors/user';
import { useSelector } from 'react-redux';
import {
    NameSection,
    RoleText,
    DetailSection,
    ItemText,
    ColumnHeader,
    TableSection,
    SearchSection,
    EmployeesContainer,
    DescriptionService,
    ItemDescription,
    AvailabilitySection,
    AvailableText,
    ImageCustom
} from './styles';

const template = (props) => {
    const { t, i18n } = useTranslation();
    const havePermission = useSelector(isUserAdmin());
    const SearchIcon = <img src={searchIcon} />;
    const { serviceList, activeCompany } = props;

    const columns = [
        {
            key: 'image',
            fixed: 'left',
            title: function titleHeader() {
                return <ColumnHeader>{t('ITEMS')}</ColumnHeader>;
            },
            dataIndex: 'description',
            width: 150,
            render: function eachItemName(name, row) {
                return (
                    <NameSection>
                        <ImageCustom
                            className="ant-image-custom"
                            src={
                                row.image?.lowres?.url
                                    ? row.image.lowres.url
                                    : null
                            }
                            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                        />
                    </NameSection>
                );
            }
        },
        {
            key: 'items',
            sorter: (a, b) => {
                if (a.name.toUpperCase() < b.name.toUpperCase()) {
                    return -1;
                }
                if (a.name.toUpperCase() > b.name.toUpperCase()) {
                    return 1;
                }
                return 0;
            },
            dataIndex: 'name',
            width: 400,
            render: function eachItemName(name, row) {
                return (
                    <NameSection>
                        <DescriptionService>
                            <ItemText>{name}</ItemText>
                            <ItemDescription>{row.description}</ItemDescription>
                        </DescriptionService>
                    </NameSection>
                );
            }
        },
        {
            key: 'type',
            width: '15%',
            title: function titleHeader() {
                return <ColumnHeader>{t('TYPE')}</ColumnHeader>;
            },
            dataIndex: 'item_type',
            filters: [
                {
                    text: t('MAIN_DISH').toUpperCase(),
                    value: 'MAIN_DISH'
                },
                {
                    text: t('STARTERS').toUpperCase(),
                    value: 'STARTERS'
                },
                {
                    text: t('WINE').toUpperCase(),
                    value: 'WINE'
                },
                {
                    text: t('DESSERTS').toUpperCase(),
                    value: 'DESSERTS'
                }
            ],
            onFilter: (value, record) => record.item_type.includes(value),
            render: function eachItemRole(type) {
                return <RoleText>{t(type).toUpperCase()}</RoleText>;
            }
        },
        {
            key: 'price',
            width: '15%',
            title: function titleHeader() {
                return <ColumnHeader>{t('PRICE')}</ColumnHeader>;
            },
            dataIndex: 'price',
            sorter: (a, b) => {
                if (a.price.value < b.price.value) {
                    return -1;
                }
                if (a.price.value > b.price.value) {
                    return 1;
                }
                return 0;
            },
            render: function eachItemEmail(price) {
                return (
                    <ItemText>
                        {numberFormat(price.value, price.currency)}
                    </ItemText>
                );
            }
        },
        {
            key: 'availability',
            width: '15%',
            title: function titleHeader() {
                return <ColumnHeader>{t('AVAILABILITY')}</ColumnHeader>;
            },
            dataIndex: 'available',
            render: function eachItemPhone(available, row, index) {
                return (
                    <AvailabilitySection>
                        <Switch
                            checked={available}
                            style={{ marginLeft: 5 }}
                            onChange={() => {
                                props.changeAvailable(row.id);
                            }}
                        />
                        <AvailableText enable={available}>
                            {available
                                ? t('AVAILABLE').toUpperCase()
                                : t('NOT_AVAILABLE').toUpperCase()}
                        </AvailableText>
                    </AvailabilitySection>
                );
            }
        },
        {
            key: 'detail',
            width: '15%',
            dataIndex: 'id',
            render: function eachItem(id) {
                return (
                    <DetailSection>
                        <ButtonCustom
                            btnType="secondary"
                            size="small"
                            title={t('VIEW_DETAILS').toUpperCase()}
                            width="120px"
                            onClick={(val) => {
                                props.navigate(SERVICES_DETAIL, id, null);
                            }}
                        />
                    </DetailSection>
                );
            }
        }
    ];

    return (
        <EmployeesContainer>
            <Header
                title={t('SERVICE_ITEMS')}
                description={t('SERVICE_ITEMS_FOR_TRIPS')}
                headerRight={() => {
                    return (
                        <>
                            {havePermission ? (
                                <ButtonCustom
                                    btnType="secondary"
                                    width="190px"
                                    onClick={() => {
                                        props.navigate(ADD_NEW_SERVICES);
                                    }}
                                    title={t('CREATE_NEW_ITEM').toUpperCase()}
                                />
                            ) : null}
                        </>
                    );
                }}
            />
            <SearchSection>
                <Row style={{ width: '100%' }}>
                    <Col xl={6} lg={7} md={8} sm={10} xs={12}>
                        <Input
                            placeholder={t('SEARCH')}
                            allowClear
                            suffix={SearchIcon}
                            onChange={(e) => props.onSearch(e)}
                            style={{ width: '100%' }}
                        />
                    </Col>
                </Row>
            </SearchSection>
            <TableSection>
                <Table
                    scroll={{ x: 1200 }}
                    columns={columns}
                    pagination={{ showSizeChanger: false }}
                    dataSource={serviceList}
                    locale={localeEmptyTable()}
                ></Table>
            </TableSection>
        </EmployeesContainer>
    );
};

export { template };
